<template>
  <div class="ceremony">
    <section class="fullscreen flex-container">
      <Header />
    </section>
    <Content title="Ceremony" icon="rings-wedding">
      <CopyWithImage
        :src="require('@/assets/images/glentana-beach.jpg')"
        flexDirection="row-reverse"
      >
        <p>
          There are two main options with flights. <b>Fly to George</b> or fly
          to <b>Cape Town</b>. We are recommending people fly between the 25th
          and the 2nd. Accomodation will be limited from the 2nd of December.
        </p>

        <p>
          The ceremony will take place on Glentana beach at 4pm.
        </p>
        <p>Dress code is smart casual but no shoes required!</p>
        <p>The reception will take place at the house</p>
        <p>
          Food will be a buffet style Braai (Barbecue) featuring a spit lamb.
        </p>
        <p>&nbsp;</p>
        <ButtonLink
          type="primary"
          href="http://www.google.com/calendar/event?action=TEMPLATE&text=Tom+and+Annette'sWedding&dates=20191130T000000Z/20191130T115959Z&details=We+lookng+forward+to+seeing+you+at+our+wedding.+For+all+the+latest+updates+please+keep+an+eye+on+our+website&location=Glentana,+Groot+Brakrivier,+South+Africa"
          target="_blank"
          icon="rings-wedding"
        >
          Add to Google Calendar
        </ButtonLink>
      </CopyWithImage>
    </Content>
  </div>
</template>

<script>
import Header from '@/components/ui/Header.vue';
import Content from '@/components/ui/Content.vue';
import ButtonLink from '@/components/ui/ButtonLink.vue';
import CopyWithImage from '@/components/ui/CopyWithImage.vue';

export default {
  name: 'Accommodation',
  components: {
    Header,
    Content,
    CopyWithImage,
    ButtonLink
  }
};
</script>

<style lang="scss" scoped>
.ceremony {
  text-align: center;
}

> section:first-of-type {
  min-height: 10vh;

  @include respond-below(sm) {
    padding: $padding;
  }
}

.section__two {
  background: white;
}
</style>
